import Router from "next/router";

export function bindCypressBridge() {
  if (process.browser) {
    window.cypressBridge = window.cypressBridge || {
      operationCount: 0,
      routeLoading: false,
    };
    window.cypressBridge.routeLoading = false;
  }

  Router.events.on("routeChangeStart", () => {
    window.cypressBridge.routeLoading = true;
  });
  Router.events.on("routeChangeComplete", () => {
    window.cypressBridge.routeLoading = false;
  });
  Router.events.on("routeChangeError", () => {
    window.cypressBridge.routeLoading = false;
  });
}
